import { createFileRoute } from '@tanstack/react-router'
import { TrendAnalysisTab } from '@/features/incidents/reports/trend-analysis/trend-analysis-tab'

export const Route = createFileRoute(
  '/_authenticated/_organization/incidents/reports/trend-analysis'
)({
  component: TrendAnalysisTab,
})
